import { NgClass, NgFor, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { EpcotConfig, MarketGroupingConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { ParticipantImageService } from '@frontend/sports/participant-image/feature';
import { TrackingService } from '@frontend/sports/tracking/feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BetBuilderOptionComponent } from './bet-builder-option.component';
import { MarketHelpComponent } from './market-help/market-help.component';
import { OptionGroupRendererDirective } from './option-group-renderer.directive';
import { RegularOptionGroupComponent } from './regular-option-group.component';

@Component({
    selector: 'ms-bet-builder-standard-option-group',
    templateUrl: './bet-builder-standard-option-group.component.html',
    providers: [ParticipantImageService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, NgClass, MarketHelpComponent, BetBuilderOptionComponent, OptionGroupRendererDirective, IconCustomComponent],
})
export class BetBuilderStandardOptionGroupComponent extends RegularOptionGroupComponent {
    constructor(
        sitecore: Sitecore,
        trackingService: TrackingService,
        epcotConfig: EpcotConfig,
        marketGroupingConfig: MarketGroupingConfig,
        participantImageService: ParticipantImageService,
    ) {
        super(sitecore, trackingService, epcotConfig, marketGroupingConfig, participantImageService);
    }
}
